/**
 * url에서 dev, qa 프리픽스 추출
 * @param {string} url
 * @returns {string|undefined} dev, qa 프리픽스 (없으면 undefined)
 */
export const getEnvPrefix = (url) => {
  return url.match(/^(https?:\/\/)(dev|qa)/)?.[2]
}
